import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin, FiLinkedin, FiInstagram, FiFacebook } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 border-b border-slate-700 pb-12">
          
          <div className="space-y-4">
            <h3 className="text-2xl font-bold tracking-tight">
              NORDBLICK<span className="text-cyan-400 font-light"> Recruiting</span>
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              Ihr verlässlicher Partner für Personalvermittlung im Norden. Klar, direkt und hanseatisch zuverlässig.
            </p>
            <div className="flex space-x-4 pt-2">
              <a href="#" className="text-slate-400 hover:text-white transition-colors"><SafeIcon icon={FiLinkedin} className="h-5 w-5" /></a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors"><SafeIcon icon={FiInstagram} className="h-5 w-5" /></a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors"><SafeIcon icon={FiFacebook} className="h-5 w-5" /></a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-slate-200">Für Sie</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/bewerber" className="hover:text-cyan-400 transition-colors">Für Bewerber</Link></li>
              <li><Link to="/unternehmen" className="hover:text-cyan-400 transition-colors">Für Unternehmen</Link></li>
              <li><Link to="/jobs" className="hover:text-cyan-400 transition-colors">Aktuelle Stellenangebote</Link></li>
              <li><Link to="/ueber-uns" className="hover:text-cyan-400 transition-colors">Über Nordblick</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-slate-200">Kontakt</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="h-5 w-5 text-cyan-500 shrink-0" />
                <span>Barmbeker Str. 9a<br />22303 Hamburg</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="h-5 w-5 text-cyan-500 shrink-0" />
                <span>0160 5074 395</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiMail} className="h-5 w-5 text-cyan-500 shrink-0" />
                <a href="mailto:info@nordblick-recruiting.de" className="hover:text-cyan-400">info@nordblick-recruiting.de</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-slate-200">Bürozeiten</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li className="flex justify-between"><span>Mo - Do:</span> <span>09:00 - 17:00 Uhr</span></li>
              <li className="flex justify-between"><span>Freitag:</span> <span>09:00 - 15:00 Uhr</span></li>
              <li className="flex justify-between"><span>Sa - So:</span> <span>Geschlossen</span></li>
            </ul>
          </div>

        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500">
          <p>&copy; {new Date().getFullYear()} Nordblick Recruiting. Alle Rechte vorbehalten.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;